// @uifabric/experiments@6.64.1
  // Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
  import { setVersion } from '@uifabric/set-version';
  setVersion('@uifabric/experiments', '6.64.1');